import script from "./DownloadsView.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadsView.vue?vue&type=script&setup=true&lang=js"

import "./DownloadsView.vue?vue&type=style&index=0&id=89430dac&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_db7f3463623555724ece677ccfae2485/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89430dac"]])

export default __exports__